import { UPDATE_STATUS, EDIT_SEARCH } from "./actionTypes";

const initialState = { status: "showAll", search: "" };

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {

    case UPDATE_STATUS: {
      const status = action.payload;
      return { ...state, status };
    }

    case EDIT_SEARCH: {
      const search = action.payload;
      return { ...state, search };
    }

    default:
      return state;
  }
};

export default filtersReducer;
